import axios, { AxiosError } from 'axios';
import { parseAxiosError } from '../common/constant';
import { BASEURL, LEAVE_MANAGEMENT_URL } from './const';
import moment from 'moment';

/* HTTP Request Interceptor to add headers on all API calls */
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        Promise.reject(error);
    }
)

export const getUsers = async (email:any): Promise<any> => {
    try {
        const response = await axios.get(`${BASEURL}/base/org-chart?email=${Array.from(email)}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getUserDetailsWithEmail = async (email:string): Promise<any> => {
    try {
        const response = await axios.get(`${BASEURL}/base/users`,{
            params :{email}
        });
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getOrgChartUser = async (chartId: string, email: string, token: string): Promise<any> => {
    try {
        const response = await axios.get(`${BASEURL}/base/org-chart-user?orgChartId=${chartId}&email=${email}`, {
            headers: {
                'x-user-id': token
            }
        });
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const downloadUserReport = async (userName: Array<string>): Promise<any> => {
    try {
        let query ='';
        userName.map(e => query +=`userName=${e}&`);
        
        const response = await axios.get(`${LEAVE_MANAGEMENT_URL}leave/download-report?${query}`, {
            responseType: 'blob'
        });
        const blob = new Blob([response?.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const today = moment().format('YYYY-MM-DD');
    
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `${today}.xlsx`);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getUserActivityDetails = async (userName: Array<string>, fromDate: string, toDate: string, platform: string, ticketOptions: string[], chartId?: string, userId?: string, AllUsers?: any, signal?: AbortSignal): Promise<any> => {
    try {      
        const payload = {
            date_from: fromDate,
            date_to: toDate,
            userName, platform,
            option: ticketOptions,
            chartId,
            userId,
            AllUsers
        }
        const response = await axios.post(`${BASEURL}/base/activity`, payload, { signal });        
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const updateActivityDetails = async ( id: string, fields: Record<string, any>) => {
    try{
        const payload = {
            id: id,
            fields: fields
        }
        // const response = await axios.post(`${BASEURL}/base/update-task`, payload);  // priortization points edit option will added in future if required
        return {}
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

// export const getUserActivityCommits = async (fromDate: string, toDate: string, userName: string, issueKey: string[], platform: string): Promise<any> => {
//     try{
//         const response = await axios.post(`${LEAVE_MANAGEMENT_URL}leave/commits`, {
//             date_from: fromDate, date_to: toDate, userName,issueKey,  platform
//         })
//         return response?.data
//     } catch (error: any) {
//         return parseAxiosError(error as AxiosError);
//     }
// };

export const getUserActivityCommits = async (fromDate: string, toDate: string, userName: string, issueKey: string[]): Promise<any> => {
    try{
        const response = await axios.post(`${BASEURL}/gitlab/commits`, {
            dateFrom: fromDate, dateTo: toDate, userName,issueKey
        })
        return response?.data
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
};

export const getUserActivityCommentsOpenProject = async (field:string,  issueKey: string, platform: string): Promise<any> => {
    try{
        const response = await axios.post(`${BASEURL}/base/task-details`, {
           field, issueKey,  platform
        })
        return response?.data
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
};
export const getUserSession = async (email: string, platform: string): Promise<any> => {
    try {      
        const response = await axios.get(`${BASEURL}/base/user-session?email=${email}&platform=${platform}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

interface createUserSessionParam {
    email: string,
    platform: string
    accountId: string,
}

export const createUserSession = async (payload: createUserSessionParam): Promise<any> => {
    try {      
        const response = await axios.post(`${BASEURL}/base/user-session`, payload);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const deleteUserSession = async (email: string, platform: string): Promise<any> => {
    try {      
        const response = await axios.delete(`${BASEURL}/base/user-session?email=${email}&platform=${platform}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}
